export default "__VITE_ASSET__CJfLIGfk__"